<template>
  <button
    @click="$emit('click')"
    v-html="label"
  />
</template>

<script>
  export default {
    name: 'Button',
    props: {
      label: {
        type: String,
        default: '',
      },
    },
  };
</script>


<style scoped lang="stylus">
  @require '~@/style/type'
  @require '~@/style/colors'

  button
    @extend $type-small, $type-semibold
    outline: none
    text-transform: uppercase
    letter-spacing: 0.05em
    border-radius: 3px
    appearance: none
    border: none
    background-color: var(--color-primary)
    color: #fff
    display: block
    height: 50px
    cursor: pointer
    transition: background-color .2s
    &:hover
      background-color: var(--color-primary-dark-1, var(--color-primary))
    &:active
      background-color: var(--color-primary-dark-2, var(--color-primary))
</style>
